<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import { Badge, Icon, percentage, integer } from '@smatch/cassiopeia-web-components';

    /* TYPES ----------------------------------------------------------------------------------- */

    import type { Auction } from 'src/app/types';
    type Rate = NonNullable<Auction['match']>['rate'];
    type Style = 'outline' | 'strong' | 'subtle';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let rate: Rate | undefined;
    export let items: number | undefined;
    export let size: 'lg' | 'md' | 'sm' = 'md';

    /* INTERNALS -------------------------------------------------------------------------------- */

    let style: Style = 'subtle';

    $: isStrong = rate !== undefined && rate > 0.75;
    $: style = isStrong ? 'strong' : 'subtle';

</script>

{#if rate !== undefined && rate > 0.5 && items !== undefined}
    <Badge
        color = 'quaternary'
        { style }
        { size }
        description = { `${ integer(items, false) } of items in this deal match your notification settings.` }
    >
        <Icon
            key = 'heartCheck'
            css = { `h-3 inline-block mt-px align-top ${ isStrong ? 'stroke-light' : 'stroke-quaternary' }` }
        />
        { percentage(rate) }
    </Badge>
{/if}